import { USER_ROLE, MENU_ID } from '@/constants/consts'

export const roleMenuMapping = {
  [USER_ROLE.ADMIN]: [
    MENU_ID.DASHBOARD,
    MENU_ID.MONITORING,
    MENU_ID.HOME,
    MENU_ID.PROJECT,
    MENU_ID.EXPLORER,
    MENU_ID.MANAGEMENT,
  ],
  [USER_ROLE.PROJECT_MANAGER]: [
    MENU_ID.HOME,
    MENU_ID.PROJECT,
    MENU_ID.EXPLORER,
    MENU_ID.WORKSPACE,
  ],
  [USER_ROLE.RESEARCHER]: [MENU_ID.HOME, MENU_ID.PROJECT, MENU_ID.EXPLORER, MENU_ID.WORKSPACE],
  [USER_ROLE.COOPERATION_PARTNER]: [MENU_ID.HOME, MENU_ID.PROJECT, MENU_ID.EXPLORER, MENU_ID.WORKSPACE],
}

// 비로그인 사용자 허용 공개 메뉴 없음 (로그인 필수 정책)
export const publicMenus: string[] = []
